import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=4bc5ffed"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=4bc5ffed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports